export const EURO_FORMAT = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' })
